import Model, { attr, belongsTo } from '@ember-data/model';

export default class ProjectVersionFileVersionBatchModel extends Model {
  @belongsTo('project-version', { inverse: null, async: false }) projectVersion;

  @attr files;
  @attr filesToUpload;
}
